import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-solid-svg-icons';
import './index.css';

interface SCLoadingOverlayProps {
  Visible: boolean;
  Label?: string;
}

function SCLoadingOverlay(props: SCLoadingOverlayProps) {
  const getLabel = () => {
    if (props.Label == undefined || props.Label == null) {
      return 'Loading...';
    } else {
      return props.Label;
    }
  };

  if (props.Visible == false) return null;
  return (
    <div className="sc-loading-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
        <FontAwesomeIcon className="sc-loading-icon" icon={faSpinnerThird} spin />
        <p className="sc-loading-label">{getLabel()}</p>
      </div>
    </div>
  );
}

export { SCLoadingOverlay };
